export default __webpack_public_path__ + "images/f86d25ad70df46813740b1152ce7bc12.svg";